import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {ScoreboardWidgetController} from "../scoreboard-widget.controller";

export class ScoreboardWidgetProps extends BaseModuleProps {
  controller: ScoreboardWidgetController;
  gameId: Number;
}
